import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "list-skeleton" },
    _vm._l(_vm.itemListNumber, function (index) {
      return _c(VSkeletonLoader, { key: index, attrs: { type: "text" } })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }